<template>
  <div id="con">
    <img v-lazy="path" />
    <p v-show="title">{{ title }}</p>
  </div>
</template>

<style scoped>
#con {
  width: 100%;
  margin-bottom: 16px;
}
#con > img {
  border: 4px solid #efefef;
  width: calc(100% - 8px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.27), 0 0 60px rgba(0, 0, 0, 0.1) inset;
}
#con > p {
  text-align: center;
  font-size: 16px;
  color: #606266;
  display: block;
  padding: 8px 0;
  letter-spacing: 4px;
  width: 100%;
  overflow: hidden;
  height: 33px;
  line-height: 33px;
}
</style>

<script>
export default {
  props: ["path", "title", "letterSpacing"]
};
</script>
